import {
  CheckCircle,
  PersonAddAlt1,
  PlayCircleOutline,
  RestartAlt,
} from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../common/enums/enums';

export default function WOrderTagMenu({
  anchorEl,
  open,
  setAnchorEl,
  data,
  handleMenuClick,
  addTechnician,
  handleStartDone,
  stepIsInDone,
  stepIsInProcess,
  pending_approval,
  enableStartLink,
  enableDoneLink,
}) {
  const { t } = useTranslation('workOrdersTable');
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      disabled
    >
      {!stepIsInDone ? (
        <MenuItem
          sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
          disabled={pending_approval}
          onClick={() => handleMenuClick(addTechnician)}
        >
          <PersonAddAlt1 sx={{ marginRight: '8px' }} />
          {t('detail.orderTag.kebab.technician')}
        </MenuItem>
      ) : null}
      {!stepIsInProcess && !stepIsInDone && (
        <MenuItem
          sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
          disabled={!enableStartLink}
          onClick={() =>
            handleMenuClick(() =>
              handleStartDone({
                vendorOrderId: data?.vendorOrderId,
                status: ProcessStep.IN_PROCESS,
              })
            )
          }
        >
          <PlayCircleOutline sx={{ marginRight: '8px' }} />
          {t('detail.orderTag.kebab.start')}
        </MenuItem>
      )}
      {stepIsInProcess && (
        <MenuItem
          sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
          disabled={!enableDoneLink}
          onClick={() =>
            handleMenuClick(() =>
              handleStartDone({
                vendorOrderId: data?.vendorOrderId,
                status: ProcessStep.DONE,
              })
            )
          }
        >
          <CheckCircle sx={{ marginRight: '8px' }} />
          {t('detail.orderTag.kebab.done')}
        </MenuItem>
      )}
      {stepIsInDone && (
        <MenuItem
          onClick={() =>
            handleMenuClick(() => {
              handleStartDone({
                vendorOrderId: data?.vendorOrderId,
                status: ProcessStep.IN_PROCESS,
              });
            })
          }
        >
          <RestartAlt sx={{ marginRight: '8px' }} />
          {t('detail.orderTag.kebab.restore')}
        </MenuItem>
      )}
    </Menu>
  );
}
